import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, bonusValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="border-y border-primary/30 bg-surface py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-18" data-mp="1ydi6yabp1vla">
      <div className="mx-auto max-w-4xl px-4" data-id="element-19" data-mp="1annvnx70wf35">
        <SectionHeading id="bonus-title" data-id="element-20" data-mp="1amcrvxdkv7c1">The {totalBonuses} <span className="text-accent" data-id="element-21" data-mp="15q5ke05j9nrz">Exclusive Bonuses</span></SectionHeading>

        <ul className="mt-10 overflow-hidden rounded-2xl border border-primary/60 bg-background shadow-lg shadow-black/30" data-id="element-22" data-mp="1jgisc2ifd2hb">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.li key={bonus.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.28,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex gap-4 border-b border-primary/15 p-5 last:border-b-0 sm:p-6" data-id="element-23" data-mp="qzy7s127iyz7" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-highlight/50 bg-surface text-highlight" data-id="element-24" data-mp="2jj7f47mo4y2u">
                  <Icon className="glow-led h-5 w-5" aria-hidden="true" data-id="element-25" data-mp="1qtgztv9avq55" />
                </span>
                <div className="min-w-0 flex-1" data-id="element-26" data-mp="1vsbupvkjl55m">
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-accent" data-id="element-27" data-mp="1vt3g6dkfdmi6">Bonus {bonus.number}</p>
                  <h3 className="mt-1 text-lg font-extrabold uppercase leading-tight text-foreground" data-id="element-28" data-mp="20q3icde5m540">{bonus.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-muted" data-id="element-29" data-mp="25o53d3v54ei4">{bonus.description}</p>
                </div>
                <div className="shrink-0 text-right" data-id="element-30" data-mp="3h5elnn2j90hu">
                  <p className="whitespace-nowrap text-xs font-semibold text-muted line-through decoration-accent decoration-2" data-id="element-31" data-mp="3h3tp5rwnr7hc">{bonusValue}</p>
                  <p className="mt-0.5 text-base font-extrabold uppercase tracking-wide text-accent" data-id="element-32" data-mp="1c4kigjyrjejy">Free</p>
                </div>
              </motion.li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-2xl border-2 border-accent bg-background px-6 py-6 text-center shadow-lg shadow-black/40 sm:flex-row sm:text-left" data-id="element-33" data-mp="1q1r1mfneff9p">
          <div data-id="element-34" data-mp="yajftf4ox7eb">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-muted" data-id="element-35" data-mp="te2vkw0m3d6i">Value of all {totalBonuses} bonuses</p>
            <p className="mt-1 text-3xl font-bold tracking-tight text-muted line-through decoration-accent decoration-2" data-id="element-36" data-mp="175hgx9hzrqgq">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-37" data-mp="eoeqrkt81we1">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-muted" data-id="element-38" data-mp="enddd9oqgxt5">Your price today</p>
            <p className="mt-1 inline-flex items-center gap-2 text-4xl font-bold tracking-tight text-accent" data-id="element-39" data-mp="an2zzbym3549">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-40" data-mp="hbiopf5ssci" /> FREE
            </p>
          </div>
        </div>
      </div>
    </section>;
}